import WebStorage from '@/Utils/WebStorage.js';

const maxHistoryLength = 9;

export function addRecentlyViewedProjectId(projectId) {
    if (!projectId) {
        return;
    }

    const recentlyViewedProjects = recentlyViewedProjectsStore.get() || [];
    const existingIndex = recentlyViewedProjects.indexOf(projectId);

    if (existingIndex !== -1) {
        recentlyViewedProjects.splice(existingIndex, 1);
    }

    recentlyViewedProjects.unshift(projectId);

    if (recentlyViewedProjects.length > maxHistoryLength) {
        recentlyViewedProjects.pop();
    }

    recentlyViewedProjectsStore.set(recentlyViewedProjects);
}

export function getRecentlyViewedProjectIds() {
    return recentlyViewedProjectsStore.get() || [];
}

const recentlyViewedProjectsStore = new WebStorage('recentlyViewedProjects');